module.exports = __webpack_public_path__ + "static/media/B_tech_black.5c5d9723.png";